<template>
  <div>
    <div class="form-exec">
      <div class="form-rows">
        <div class="card-title">
          <el-link @click="loadFormData">经纪人</el-link>
        </div>
        <div class="formCard" v-loading="loading">
          <el-row :gutter="15">
            <el-col :span="24">
              <!--              执行操作表单-->
              <ExecForm :form-data.sync="formData" @loadFormData="loadFormData"/>
              <!--              发布链接等-->
              <PublishLinkForm :form-data.sync="formData" @loadFormData="loadFormData"/>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getOrderDetailExec} from "@/api/order";
import PublishLinkForm from "@/views/adOrder/components/detail/PublishLinkForm";
import ExecForm from "@/views/adOrder/components/detail/ExecForm";

export default {
  name: "PartExec",
  components: {ExecForm, PublishLinkForm},
  props: {
    isOperate: {
      type: Number,
      default() {
        return 0
      }
    },
    orderId: {
      type: [Number, String],
      required: true
    },
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
  },
  data() {
    return {
      loading: false,
      formData: {
        id: null,
        bool_exec: null,
        exec_timestamp: null,
        publish_link: []
      }
    }
  },
  methods: {
    async loadFormData() {
      this.loading = true
      //获取订单信息 getOrderDetailBase
      let {info} = await getOrderDetailExec({id: this.orderId}).then((res) => {
        return res.model;
      })
      info.publish_link = info.publish_link || ['']
      info.publish_link = typeof info.publish_link === 'string' ? [info.publish_link] : info.publish_link
      this.formData = info
      this.loading = false
      this.$forceUpdate()
    },
  },
  created() {
    this.loadFormData()
  }
}
</script>

<style scoped>
.card-title {
  position: relative;
  /*padding-top: 24px;*/
  padding-left: 55px;
  margin-bottom: 15px;
  color: rgba(50, 50, 50, 1);
  line-height: 24px;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
}

.card-title::after {
  content: "";
  position: absolute;
  bottom: 6.5px;
  left: calc(55px - 8px - 6px);
  width: 8px;
  height: 8px;
  background: rgba(224, 63, 61, 1);
  border-radius: 2px;

}

.formCard {
  padding: 24px 20px;
  border-radius: 6px;
  border: 1px solid rgba(221, 221, 221, 1);
  /*margin-bottom: 16px;*/
  width: 95%;
  margin: 5px auto;
}

.form-rows {
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 6px;
  padding: 20px;
}

.op-row {
  text-align: center;
  vertical-align: middle;
  /*border: 1px solid rgba(221, 221, 221, 1);*/
  border-radius: 6px;
  line-height: 1;
  padding: 24px 20px;
}

.btn-operation {
  border-radius: 2px;
  font-size: 14px;
  padding: 12px 20px;
}

.edit-btn {
  margin-left: 5px;
}

.is-label {
  font-weight: 800;
  color: #606266;
}

.is-value {
  font-weight: 400;
  margin-right: 10px;
  color: #606266;
}

.rebates_rate::after {
  content: ' %';
}

.commission_rate::after {
  content: ' %';
}

.calc-res {
  font-weight: 600;
  font-size: 1.2em;
  color: #F56C6C;
}

.input-val {
  min-width: 120px;
  width: 200px;
  max-width: 300px;
  overflow-x: hidden;
  /*display: flex;*/
  text-align: center;
  /*border: 1px dashed rebeccapurple;*/
  border: 1px solid rgb(220, 223, 230);
  padding-left: 5px;
  padding-right: 5px;
  line-height: 28px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
}

.input-val > .form-val {
  flex: 4;
  text-align: center !important;
  width: 100%;
}

.input-val > .edit-btn {
  flex: 1;
}

</style>
